<template>
</template>
<script>
  export default {
    data() {
      let vm = this;
      return {
        element: null,
        resources: {
          zIndex: {
            name: 'zIndex',
            defaultValue: '',
            labelDesc: 'zIndex',
            callback: function () {
              vm.resources.zIndex.defaultValue = this.value;
              vm.element.internal_config.zIndex = this.value;
            },
          },


          label: {
            name: 'label',
            defaultValue: '',
            labelDesc: 'label',
            canRemove: false,
            callback: function () {
              vm.resources.label.defaultValue = this.value;
              vm.element.internal_config.label = this.value;
            },
          },

          backgroundColor: {
            name: 'backgroundColor',
            defaultValue: '#ffffff',
            gradient: true,
            labelDesc: 'bg-color-header',
            callback: function () {
              vm.resources.backgroundColor.defaultValue = this.colorValue;
              vm.element.internal_config.backgroundColor = this.colorValue;
            },
          },

          border: {
            name: 'border',
            defaultValue: '1px solid black',
            min: '0',
            max: '50',
            labelDesc: 'border',
            callback: function () {
              let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

              vm.resources.border.defaultValue = value;
              vm.element.internal_config.border = value;
            },
          },

          borderRadius: {
            name: 'borderRadius',
            defaultValue: '0 0 0 0',
            min: '0',
            max: '360',
            labelDesc: 'borderRadius',
            callback: function () {

              let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

              vm.resources.borderRadius.defaultValue = value;
              vm.element.internal_config.borderRadius = value;
            },
          },
          src: {
            defaultValueOrigin: '',
            defaultValueSize: '',
            defaultValueRepeat: '',

            name: 'src',
            defaultValue: '',
            labelDesc: 'bg-image',
            canExternal: true,
            canRemove: true,
            callback: function () {
              vm.resources.src.defaultValue = this.value;
              vm.resources.src.defaultValueOrigin = this.origin;
              vm.resources.src.defaultValueRepeat = this.repeat;
              vm.resources.src.defaultValueSize = this.size;
              vm.resources.src.defaultValuePosition = this.position;
              vm.resources.src.defaultValueAttachment = this.attachment;

              vm.element.internal_config.backgroundImage = this.value;
              vm.element.internal_config.backgroundOrigin = this.origin;
              vm.element.internal_config.backgroundRepeat = this.repeat;
              vm.element.internal_config.backgroundSize = this.size;
              vm.element.internal_config.backgroundPosition = this.position;
              vm.element.internal_config.backgroundAttachment = this.attachment;


              //force apply new bg
              let color = vm.element.internal_config.backgroundColor;
              vm.element.internal_config.backgroundColor = '#FFFFFF';
              vm.element.internal_config.backgroundColor = color;
            },
          },


          padding: {
            name: 'padding',
            defaultLeft: '15',
            defaultTop: '15',
            defaultRight: '15',
            defaultBottom: '15',
            min: '0',
            max: '100',
            labelDesc: 'padding',
            callback: function () {
              vm.resources.padding.defaultLeft = this.l;
              vm.element.internal_config.paddingLeft = this.l + 'px';

              vm.resources.padding.defaultTop = this.t;
              vm.element.internal_config.paddingTop = this.t + 'px';

              vm.resources.padding.defaultRight = this.r;
              vm.element.internal_config.paddingRight = this.r + 'px';

              vm.resources.padding.defaultBottom = this.b;
              vm.element.internal_config.paddingBottom = this.b + 'px';
            },
          },
        }
      }
    },
    methods: {
      setValuesData(data) {
        this.element = data;

        this.resources.label.defaultValue = data.internal_config.label;

        this.resources.border.defaultValue = data.internal_config.border;
        this.resources.borderRadius.defaultValue = data.internal_config.borderRadius;
        this.resources.backgroundColor.defaultValue = data.internal_config.backgroundColor;
        this.resources.src.defaultValue = data.internal_config.backgroundImage;
        this.resources.src.defaultValueOrigin = data.internal_config.backgroundOrigin;
        this.resources.src.defaultValueRepeat = data.internal_config.backgroundRepeat;
        this.resources.src.defaultValueSize = data.internal_config.backgroundSize;
        this.resources.src.defaultValueAttachment = data.internal_config.backgroundAttachment;
        this.resources.src.defaultValuePosition = data.internal_config.backgroundPosition;

        this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
        this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
        this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
        this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);
      },
      getValuesData() {
        return this.resources;
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/SliderDropGallery/SliderPage/Resources.vue